<div class="form-container1" *ngIf="init" [formGroup]="firstFormGroup">

    <!-- HEADER -->
    <div class="header-row-new">
        <div class="header-text">
            <mat-icon>home</mat-icon>
            <mat-icon>
                {{ type == 1 ? 'email' :
                type == 2 ? 'phone' :
                type == 3 ? 'network_node' :
                type == 4 ? 'chat_bubble' : '' }}
            </mat-icon>
            <span class="header-title">
                {{ type == 1 ? 'Email' :
                type == 2 ? 'Call' :
                type == 3 ? 'LinkedIn' :
                type == 4 ? 'WhatsApp' : '' }}
            </span>
        </div>

        <div class="header-actions">
            <div *ngIf="tasks?.length" class="task-nav">
                <button [attr.guide]="'task-popup-btn-1' + '__' + sanitizedUrl" mat-icon-button (click)="prevTask()"
                    [disabled]="currentIndex===0">
                    <mat-icon>chevron_left</mat-icon>
                </button>
                <span>{{currentIndex + 1}} / {{tasks.length}}</span>
                <button [attr.guide]="'task-popup-btn-2' + '__' + sanitizedUrl" mat-icon-button (click)="nextTask()"
                    [disabled]="currentIndex + 1 >= tasks.length">
                    <mat-icon>chevron_right</mat-icon>
                </button>
            </div>

            <button [attr.guide]="'task-popup-btn-3' + '__' + sanitizedUrl" mat-icon-button (click)="close()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

    <!-- SCROLLABLE CONTENT -->
    <div class="form-content">

        <!-- BASIC INFO -->
        <div class="section info-section">
            <div class="line">
                <mat-icon>person</mat-icon>
                <span style="cursor: pointer;"
                    (click)="leadNavigation(firstFormGroup.value.leadId)">{{firstFormGroup.value.firstName}}</span>
            </div>

            <div class="line">
                <mat-icon>business_center</mat-icon>
                <span>{{firstFormGroup.value.company}}</span>
            </div>

            <div class="line">
                <mat-icon>work</mat-icon>
                <span>{{firstFormGroup.value.jobTitle}}</span>
            </div>



            <div class="line space-between">
                <div class="line">
                    <mat-icon>telegram</mat-icon>
                    <span>{{firstFormGroup.value.taskStep}} - {{firstFormGroup.value.sequenceName}}</span>
                </div>
                <span class="duedate">{{ getDueLabel(firstFormGroup.value.dueDate) }}</span>
            </div>
        </div>

        <!-- EMAIL -->
        <ng-container *ngIf="type == 1">
            <div class="section">
                <div class="line" *ngIf="useIndividualMail == 1">
                  <mat-form-field appearance="outline" floatLabel="always" fxFlex>
                    <mat-label>From</mat-label>
                    <mat-select formControlName="fromEmailId" [disableOptionCentering]="true" #singleSelect
                      autocomplete="off" (selectionChange)="onFromEmailChange($event.value)">
                      <mat-option>
                        <ngx-mat-select-search name="Email Search" ngDefaultControl [formControl]="typeYFilterControl"
                          placeholderLabel="Email Search" [preventHomeEndKeyPropagation]="true"
                          noEntriesFoundLabel="No data found">
                        </ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let opt of filtereddropdownTypeList; let i=index;"
                        [value]="opt.userMailConfigId">
                        {{ opt.emailAddress }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="firstFormGroup.get('fromEmailId')?.errors?.required">
                      Please fill out this field.
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="line" *ngIf="useIndividualMail != 1">
                    <span class="label">From : &nbsp;</span>
                    <span class="value">{{firstFormGroup.value.fromEmail}}</span>
                </div>

                <div class="line space-between">
                    <div>
                        <span class="label">To : &nbsp;</span>
                        <span class="value">{{firstFormGroup.value.prospectEmailid}}</span>
                    </div>
                    <span class="link" (click)="toggleCcBcc()">Cc/Bcc</span>
                </div>

                <div *ngIf="showCcBcc" class="ccbcc" style="margin-top: 10px;">
                    <div class="line">
                        <span class="label" style="width: 40px;">Cc :</span>
                        <input [attr.guide]="'task-popup-inp-cc' + '__' + sanitizedUrl" type="text" class="value"
                            matInput placeholder="Enter CC" formControlName="cc" />
                    </div>

                    <div class="line" style="margin-top: 8px;">
                        <span class="label" style="width: 40px;">Bcc :</span>
                        <input [attr.guide]="'task-popup-inp-bcc' + '__' + sanitizedUrl" type="text" class="value"
                            matInput placeholder="Enter BCC" formControlName="bcc" />
                    </div>
                </div>

                <div class="line">
                    <span class="label" style="width: 80px;">Subject :</span>
                    <input [attr.guide]="'task-popup-inp-subject' + '__' + sanitizedUrl" type="text" class="value"
                        matInput placeholder="Subject" formControlName="subject" />
                </div>
            </div>

            <div class="section">
                <calsoft-doc-editor formControlName="message" mode="compose"></calsoft-doc-editor>
            </div>

            <div class="section">
                <h4>Attachments</h4>
                <div class="attachments-bar" formArrayName="attachments">
                    <div class="attachment-chip"
                        *ngFor="let attachment of firstFormGroup.get('attachments')['controls']; let k = index">
                        <span class="name">{{ attachment.value.image }}</span>
                        <button [attr.guide]="'task-popup-btn-4' + '__' + sanitizedUrl" mat-icon-button color="warn"
                            (click)="removeImageOption(k)">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                    <calsoft-common-file-upload [type]="'gmail'" (fileUploadResult)="getResultBanner($event)">
                    </calsoft-common-file-upload>
                </div>
            </div>
        </ng-container>

        <!-- CALL -->
        <ng-container *ngIf="type == 2">
            <div class="section">
                <div class="line" style="margin-bottom: 10px; display: flex; align-items: center;">
                    <mat-icon style="cursor: pointer; color: #3f51b5;" (click)="phoneNumbercall(firstFormGroup.value)">phone</mat-icon>
                    <span style="cursor: pointer; font-weight: 600; text-decoration: underline; color: #3f51b5; margin-left: 8px;" (click)="phoneNumbercall(firstFormGroup.value)">
                        {{firstFormGroup.value.phoneNo || firstFormGroup.value.phoneNumber}}
                    </span>
                </div>

                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">

                    <mat-form-field fxFlex="100" appearance="outline" *ngIf="durarationVisible">
                        <mat-label>Duration</mat-label>
                        <input [attr.guide]="'task-popup-inp-duration' + '__' + sanitizedUrl" matInput
                            formControlName="duration" />
                    </mat-form-field>
                </div>


                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">

                    <mat-form-field fxFlex="100" appearance="outline">
                        <mat-label>Notes</mat-label>
                        <textarea [attr.guide]="'task-popup-sel-notes' + '__' + sanitizedUrl" required matInput rows="3"
                            formControlName="notes"></textarea>
                        <mat-error *ngIf="firstFormGroup.controls.notes.errors?.required">
                            Please fill out this field.
                        </mat-error>
                    </mat-form-field>
                </div>


                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">

                    <mat-form-field fxFlex="100" appearance="outline">
                        <mat-label>Call Outcome</mat-label>
                        <mat-select formControlName="callOutCome" (selectionChange)="onCallOutcomeChange($event.value)">
                            <mat-option *ngFor="let s of callOutComeList" [value]="s.value">
                                {{s.viewValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                </div>

            </div>
        </ng-container>

        <!-- LINKEDIN -->
        <ng-container *ngIf="type == 3">
            <div class="section">

                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">
                    <mat-form-field fxFlex="100" appearance="outline">
                        <mat-label>Notes</mat-label>
                        <textarea [attr.guide]="'task-popup-sel-notes' + '__' + sanitizedUrl" matInput rows="4"
                            formControlName="notes"></textarea>
                    </mat-form-field>
                </div>

            </div>
        </ng-container>

        <!-- WHATSAPP -->
        <ng-container *ngIf="type == 4">
            <div class="section">
                <div class="line" style="margin-bottom: 10px;">
                    <mat-icon>phone</mat-icon>
                    {{firstFormGroup.value.phoneNo || firstFormGroup.value.phoneNumber}}
                </div>
            </div>


            <div class="section">
                <calsoft-create-campaign-template [type]="2" [fromSequence]="true" [task]="firstFormGroup.value"
                    (getInputJson)="handleInputJson($event)" (formFieldInvalid)="formFieldInvalid($event)"
                    #campaignTemplate>
                </calsoft-create-campaign-template>
            </div>

            <div class="section">
                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">

                    <mat-form-field fxFlex="100" appearance="outline">
                        <mat-label>Notes (What action did you take?)</mat-label>
                        <textarea [attr.guide]="'task-popup-sel-notes' + '__' + sanitizedUrl" matInput
                            matAutosizeMinRows=3 matAutosizeMaxRows=6
                            placeholder="Example: Sent order confirmation WhatsApp message via Business app"
                            formControlName="notes"></textarea>
                        <mat-error *ngIf="firstFormGroup.controls.notes.errors?.required">
                            Please fill out this field
                        </mat-error>
                    </mat-form-field>

                </div>

            </div>
        </ng-container>

    </div>

    <!-- FOOTER -->
    <div class="footer-container">
        <button [attr.guide]="'task-popup-btn-5' + '__' + sanitizedUrl" mat-raised-button color="primary"
            [disabled]="text !== 'Complete'" (click)="updateTaskStatus()">
            {{text}}
        </button>
    </div>

</div>